(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wcs-language-picker"] && !Shopify.designMode) return;
  try {
    /*
   * WCS: send the visitor back to the page in the address bar after a language change. The form's
   * `return_to` holds the URL that rendered the form, and in the hydrated mobile drawer that is
   * `?section_id=…__header_section`, which shows the header section alone.
   */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('wcs-language-picker__form')) return;

    const returnTo = form.elements.namedItem('return_to');
    if (returnTo instanceof HTMLInputElement) {
      returnTo.value = window.location.pathname + window.location.search;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wcs-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wcs-size-chart')) {
    customElements.define(
      'wcs-size-chart',
      class WcsSizeChart extends HTMLElement {
        connectedCallback() {
          const dialog = this.querySelector('dialog');
          const opener = this.querySelector('.wcs-size-chart__link');
          if (!dialog || !opener) return;
          opener.addEventListener('click', (event) => {
            event.preventDefault();
            dialog.showModal();
          });
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog || event.target.closest('[data-close]')) dialog.close();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
